import { BookIcon, ClipboardIcon, HomeIcon, SteeringWheelIcon, UserIcon } from '@dcs/ui/icons';
import type { ComponentType } from 'react';
import { Link, useLocation } from 'react-router';
import { t } from '../messages/vi';
import { activeTab, NAV_ITEMS, type NavTab } from './nav';
import './app-nav.css';

const ICONS: Readonly<Record<NavTab, ComponentType<{ size?: number }>>> = {
  home: HomeIcon,
  theory: BookIcon,
  exam: ClipboardIcon,
  practice: SteeringWheelIcon,
  me: UserIcon,
};

function useActiveTab(): NavTab | null {
  const { pathname, search } = useLocation();
  return activeTab(pathname, search);
}

/** "Điều hướng chính" in the header: the five sections as text links, shown from 768px. */
export function MainNav() {
  const current = useActiveTab();
  return (
    <nav className="main-nav" aria-label={t('nav.main')}>
      <ul className="main-nav__list">
        {NAV_ITEMS.map((item) => (
          <li key={item.id}>
            <Link
              to={item.to}
              className="main-nav__link"
              aria-current={item.id === current ? 'page' : undefined}
            >
              {t(item.label)}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
}

/**
 * Bottom tab bar under 768px: the same five sections, icon over label, each one a 48 px tap
 * target at least; clear of the home indicator through `env(safe-area-inset-bottom)`.
 */
export function TabBar() {
  const current = useActiveTab();
  return (
    <nav className="tabbar" aria-label={t('nav.tabbar')} data-tabbar>
      <ul className="tabbar__list">
        {NAV_ITEMS.map((item) => {
          const Icon = ICONS[item.id];
          return (
            <li key={item.id} className="tabbar__item">
              <Link
                to={item.to}
                className="tabbar__link"
                data-tab={item.id}
                aria-current={item.id === current ? 'page' : undefined}
              >
                <span className="tabbar__icon">
                  <Icon size={24} />
                </span>
                <span className="tabbar__label">{t(item.label)}</span>
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
